import Header from "@/components/Header";
import Hero from "@/components/Hero";
import RadioPlayer from "@/components/RadioPlayer";
import ChatRoom from "@/components/ChatRoom";
import NowLiveTeaser from "@/components/NowLiveTeaser";
import GlobalReach from "@/components/GlobalReach";
import Footer from "@/components/Footer";
import Ticker from "@/components/Ticker";
import TuningInTicker from "@/components/TuningInTicker";
import RequestLiveNowStrip from "@/components/RequestLiveNowStrip";
import WelcomeCard from "@/components/WelcomeCard";
import FeaturedBands from "@/components/FeaturedBands";
import TopTracks from "@/components/TopTracks";

export default function Home() {
  return (
    <div className="relative min-h-screen" data-testid="home-page">
      <WelcomeCard />
      <Header />
      <Hero />
      <RequestLiveNowStrip />
      <TuningInTicker />
      <Ticker />

      {/* Player + Chat — bento control panel (PROMOTED to top so visitors see it immediately) */}
      <section
        id="listen"
        className="relative border-t border-zinc-800"
        data-testid="player-chat-section"
      >
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-0">
          <div className="lg:col-span-8 border-b lg:border-b-0 lg:border-r border-zinc-800">
            <RadioPlayer />
          </div>
          <div className="lg:col-span-4 lg:sticky lg:top-0 lg:h-screen lg:max-h-screen flex flex-col overflow-hidden">
            <ChatRoom />
          </div>
        </div>
      </section>

      <FeaturedBands />
      <GlobalReach />
      <TopTracks />
      <NowLiveTeaser />
      <Footer />
    </div>
  );
}
